import { getFieldSwitchProps } from '@/utils';
import { memo } from 'react';

import { BorderedLayout, HeaderSection, RowItem, Switch } from '..';
import { useLogic } from './logic';
import { IProps } from './type';

const NotificationControl = (props: IProps) => {
	const { canEdit = false } = props;
	const { formik } = useLogic(props);
	return (
		<div className="bg-white">
			<HeaderSection title="알림 제어" />
			<div className="pt-[15px] px-5 pb-5">
				<h4 className="text-[15px] leading-[18px] font-medium text-font2 mb-2">
					근로자
				</h4>
				<div className="grid grid-cols-2">
					<BorderedLayout containerClassName="!border-l">
						<RowItem label="공지사항">
							<div className="flex items-center w-full">
								<Switch
									label="PUSH"
									{...getFieldSwitchProps(formik, 'isActivatedApplicantNoti')}
									disabled={!canEdit}
								/>
							</div>
						</RowItem>
					</BorderedLayout>
				</div>

				<h4 className="text-[15px] leading-[18px] font-medium text-font2 mb-2 mt-5">
					사업장
				</h4>
				<div className="grid grid-cols-2">
					<BorderedLayout>
						<RowItem label="공지사항">
							<div className="flex items-center w-full">
								<Switch
									label="PUSH"
									{...getFieldSwitchProps(formik, 'isActivatedFranchiseNoti')}
									disabled={!canEdit}
								/>
							</div>
						</RowItem>
					</BorderedLayout>
					<BorderedLayout>
						<RowItem label="근로자 출국 예정">
							<div className="flex items-center justify-evenly w-full">
								<Switch
									label="문자"
									{...getFieldSwitchProps(formik, 'isActivatedExpApplicantSms')}
									disabled={!canEdit}
								/>
								<Switch
									label="PUSH"
									{...getFieldSwitchProps(
										formik,
										'isActivatedExpApplicantNoti'
									)}
									disabled={!canEdit}
								/>
							</div>
						</RowItem>
					</BorderedLayout>
				</div>
			</div>
		</div>
	);
};

export default memo(NotificationControl);
